module.exports = __webpack_public_path__ + "static/media/SampleCalendarIcon.2b633e0a.svg";